var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoyalty = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5517 24.3203L31.3463 36.3731L20.7503 29.9777L10.1556 36.3723L12.9671 24.3203L3.60645 16.2112L15.9322 15.1654L20.7505 3.79688L25.5684 15.1472L37.8964 16.2102L28.5517 24.3203ZM28.0662 31.854L26.1252 23.5465L32.566 17.9593L24.0685 17.2221L20.7497 9.38133L17.4498 17.2041L8.95256 17.9413L15.3934 23.5285L13.4526 31.8351L20.7501 27.4295L28.0662 31.854Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoyalty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loyalty.b05d2ec3c9f726d623a0ab7147141357.svg";